import { connectWebSocket } from "../websocketSlice";
import { getSocket } from "./websocketService";

const socketMiddleware = (store) => (next) => (action) => {
  let socket = getSocket();

  if (action.type === "alertchange") {
    if (!socket) {
      console.warn("❌ No socket instance found.");
      return;
    }

    if (socket.disconnected) {
      // console.log("⚠️ WebSocket is disconnected, retrying after open...");
      socket.on("connect", () => {
        // console.log("✅ WebSocket is now open, sending message.");
        socket.emit("message", JSON.stringify(action.payload));
      });
    } else {
      // console.log("✅ WebSocket is open, sending message.");
      // console.log("📤 Sending message:", action.payload);
      socket.emit("alertchange", action.payload);
    }
  }
  if (action.type === "alertremove") {
    if (!socket) {
      console.warn("❌ No socket instance found.");
      return;
    }

    if (socket.disconnected) {
      // console.log("⚠️ WebSocket is disconnected, retrying after open...");
      socket.on("connect", () => {
        // console.log("✅ WebSocket is now open, sending message.");
        socket.emit("message", JSON.stringify(action.payload));
      });
    } else {
      // console.log("✅ WebSocket is open, sending message.");
      // console.log("📤 Sending message:", action.payload);
      socket.emit("alertremove", action.payload);
    }
  }


  if (action.type === "websocket/disconnect") {
    if (socket) {
      socket.disconnect();
      store.dispatch({ type: "websocket/connectionLost" });
    }
    socket = null;
  }

  // if (action.type === "websocket/attemptReconnect") {
  //   const { websocket, auth } = store.getState();
  //   if (!auth?.access) {
  //     // console.log("❌ Stopping reconnection: User is not authenticated");
  //     return;
  //   }
  //   if (websocket.reconnectAttempts < websocket.maxReconnectAttempts) {
  //     // console.log(`🔄 Reconnecting... Attempt ${websocket.reconnectAttempts}`);

  //     setTimeout(() => {
  //       store.dispatch(connectWebSocket());
  //     }, 2000 * websocket.reconnectAttempts);
  //   } else {
  //     // console.log("❌ Max reconnect attempts reached.");
  //   }
  // }

  return next(action);
};

export default socketMiddleware;

